<template>
<v-card flat >
  <!-- <v-toolbar dense flat color='blue-grey darken--4' >
    <v-btn @click='loadAppointment' icon><v-icon>replay</v-icon></v-btn>
    <v-toolbar-title >
    {{appointment.invoice_title || appointment.title}}
    </v-toolbar-title>
  </v-toolbar> -->
  <v-navigation-drawer right overlay fixed bottom disable-resize-watcher disable-route-watcher stateless touchless
    v-if='withCreate && createInvoice && appointment && appointment.client'
    v-model='createInvoice'
    style='z-index:15;'
    :hide-overlay='false'
    width='440' >
    <!-- <v-toolbar dense flat >
      <v-toolbar-title>Create invoice</v-toolbar-title>
      <v-btn @click='createInvoice=false' icon ><v-icon>close</v-icon></v-btn>
    </v-toolbar> -->
    <v-card flat height='100%' >
      <v-card-title class='subtitle-1 overline py-1 grey lighten-4' >
        Create an invoice
        <v-spacer />
        <v-btn icon small @click='createInvoice=false' >
          <v-icon small >close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />

      <!-- @done='createInvoice=false;' -->
      <confirm-invoice
        v-if='computedRelationship && computedRelationship.id'
        :with-header='false'
        :relationship='computedRelationship'
        :appointments='[appointment]'
        @success='loadAppointment'
        @done='$emit("close")'
        v-model='invoice'>
      </confirm-invoice>
      <!-- <v-alert :value='true' >
        We seem to be missing some important information needed to create this invoice.
        <v-btn @click='loadAppointment' >Reload data</v-btn>
      </v-alert> -->
      <!-- <quick-create
        :appointments="[appointment]"
        :client='appointment.client'
        @success='loadAppointment'
        @cancel='createInvoice=false;'
        @close='createInvoice=false;$emit("close")' /> -->
    </v-card>
  </v-navigation-drawer>

  <v-card flat >
    <v-list dense flat dark two-line
      style='position:fixed;top:0px;left:0px;right:0px;z-index:14;'
      v-if='appointment && withDone' >
      <v-list-tile >
        <v-list-tile-action >
          <v-btn small icon
            :loading='appointmentRequest.loading'
            @click='loadAppointment' ><v-icon small >replay</v-icon></v-btn>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title >
            <v-chip label dark
              v-if='formattedStatus && formattedStatus.theme'
              :class='formattedStatus.theme' class='v-chip--x-small' >
              {{ formattedStatus.title }}
            </v-chip>
            {{appointmentInvoiceTitle}}
          </v-list-tile-title>
          <v-list-tile-sub-title
            v-if='appointment.invoice_description'
            v-text='appointment.invoice_description' >
          </v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action v-if='appointmentRequest.loading' >
          <v-progress-circular indeterminate color='amber' class='mr-3' width='2' />
        </v-list-tile-action>
        <v-list-tile-action v-else >
          <v-btn small
            v-if='withCreate'
            :icon='$vuetify.breakpoint.xs'
            @click='createInvoice=true'
            color='primary' class='mr-3' >
            <v-icon small >add</v-icon>
            <span class='ml-2 hidden-xs-only' >Invoice</span>
          </v-btn>
        </v-list-tile-action>
        <v-divider vertical />
        <v-list-tile-action >
          <v-btn @click='$emit("close")' icon >
            <v-icon >close</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text class='mt-5' >
      <request-status
        :request='requests.set_discount'
        message200='Discount successfully applied' />
      <request-status
        :request='appointmentEditRequest'
        message200='Appointment details updated' />
      <request-status :request='appointmentRequest'
        :message200='false' />

      <v-layout row wrap >
        <v-flex xs12 sm6 order-xs2 order-sm1 >
          <v-checkbox
            label="Ready for invoicing"
            persistent-hint
            hint="Tick this so that you know this appointment can be safely added to invoices"
            color="success"
            @change='markAsInvoiceable'
            :loading='appointmentEditRequest.loading'
            v-model="appointment.invoiceable" >
          </v-checkbox>
        </v-flex>
        <v-flex xs12 sm6 order-xs1 order-sm2>
          <v-text-field
            box persistent-hint
            class='elevation-4 mt-2'
            id='appointmentPrice' name='appointmentPrice'
            append-icon="save"
            :loading='appointmentEditRequest.loading'
            @blur='saveAppointmentDetails'
            @append:click='saveAppointmentDetails'
            @keyup.enter='saveAppointmentDetails'
            v-model='appointment.price'
            :prefix='appointment.currency'
            :disabled='appointmentEditRequest.loading || (appointment.codes && appointment.codes.length > 0)'
            :hint='appointmentPriceHint'
            :rules="appointmentPriceRules"
            type='tel'
            label="Appointment price"  >
          </v-text-field>
          <!-- v-if='appointment.discount_amount' -->
          <v-text-field dense filled clearable
            v-if='appointment'
            :loading='requests.set_discount.loading'
            :disabled='requests.set_discount.loading'
            label='Add a discount'
            placeholder='0.00'
            v-model='appointment.discount_amount'
            :prefix='appointment.currency'
            append-icon="save"
            class="mt-2 mx-2"
            @click:clear='appointment.discount_amount=0'
            @append:click='setDiscount'
            @keyup.enter='setDiscount'
            @blur='setDiscount' >
          </v-text-field>
          <!-- :hint='discountHint' -->
          <!-- :persistent-hint='appointment.codes && appointment.codes.length > 0' -->
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
  <v-card-text>
  <v-expansion-panel
    v-model='activePanel'
    flat class='elevation-4' >
    <v-expansion-panel-content >
      <div class='subheading' slot="header">Appointment information</div>
      <v-form class='grey lighten-4'>
        <v-card flat class='grey lighten-4'>
          <v-card-text>
            <v-text-field
              name="appointment-invoice-title"
              append-icon="save"
              @blur='saveAppointmentDetails'
              @append:click='saveAppointmentDetails'
              @keyup.enter='saveAppointmentDetails'
              v-model='invoiceTitle'
              label="Invoice title"
              persistent-hint
              hint="Change the title as it appears in the invoice" >
            </v-text-field>

            <v-text-field
              id='appointmentDescription'
              name='appointmentDescription'
              v-model='invoiceDescription'
              append-icon="save"
              @blur='saveAppointmentDetails'
              @append:click='saveAppointmentDetails'
              @keyup.enter='saveAppointmentDetails'
              label='Appointment description'
              persistent-hint
              hint='You can add further information about the appointment here. For example: "knee rehab"' >
            </v-text-field>
          </v-card-text>
        </v-card>
      </v-form>
    </v-expansion-panel-content>
    <!-- <v-expansion-panel-content >
      <div class='subheading' slot="header">Customer information</div>
    </v-expansion-panel-content> -->
    <v-expansion-panel-content >
      <div
        class='subheading' slot="header">Medical aid coding</div>
      <v-form class='grey lighten-4'>
       <appointment-codes with-clone editable with-refresh with-title
          v-if='activePanel === PANELS.CODES'
          class='mt-4'
          ref='invoiceCodes'
          @pricechange='setAppointmentPrice'
          :appointment-id='appointment.id' >
       </appointment-codes>
      </v-form>
    </v-expansion-panel-content>

    <v-expansion-panel-content >
      <div class='subheading' slot="header">
        Product sales
        <!-- <v-btn style='float:right;' class='mr-5' fab right small absolute >
          <v-icon>add</v-icon>
        </v-btn> -->
      </div>
      <v-form>
        <appointment-product
          v-if='activePanel === PANELS.PRODUCTS && appointment.id'
          @updated='loadAppointment'
          :appointment-id='appointment.id' />
      </v-form>
    </v-expansion-panel-content>

    <v-expansion-panel-content >
      <div
        class='subheading' slot="header">
          {{ $t('titles.invoices') }}
      </div>
      <request-status :request='invoiceRequest' :message200='false' />
      <v-form class='grey lighten-4'>
        <h3 class='overline pa-4'>
          This appointment is included in the following invoices
        </h3 >
        <invoice-list class='pa-4'
          v-if='invoices && invoices.length > 0'
          @selected='gotoInvoice'
          transition='fade'
          :invoices='invoices' >
        </invoice-list >
        <div v-else class='px-4 pb-4' >
          No invoices found for this appointment
        </div>
      </v-form>
    </v-expansion-panel-content>

    <v-expansion-panel-content >
      <div class='subheading' slot="header">
        Payments
        <!-- <v-btn style='float:right;' class='mr-5' fab right small absolute >
          <v-icon>add</v-icon>
        </v-btn> -->
      </div>
      <v-form>
        <v-card flat >
          <payment-list with-delete
          v-if='appointment && appointment.payments'
          :appointment='appointment'
          :payments='appointment.payments' />
          <v-card-actions >
            <v-spacer />
            <v-btn small
              :disabled='isPaid'
              @click='addPaymentDialog=true;touchPayment++' >Add a payment</v-btn>
          </v-card-actions>
        </v-card>
          <v-dialog v-model='addPaymentDialog' :fullscreen='$vuetify.breakpoint.xs' >
            <v-toolbar dense flat >
              <v-toolbar-title>Add a payment</v-toolbar-title>
              <v-spacer/>
              <v-btn
                @click='addPaymentDialog=false' icon ><v-icon>close</v-icon></v-btn>
            </v-toolbar>
            <create-transaction
              v-if='activePanel === PANELS.PAYMENTS'
              @success='loadAppointment()'
              @close='addPaymentDialog=false'
              :with-appointment-info='false'
              :with-done='false'
              :touch='touchPayment'
              :appointment='appointment' />
          </v-dialog>
      </v-form>
    </v-expansion-panel-content>
  </v-expansion-panel>
  <!-- :appointment-id='appointment.id' -->
  <!-- {{appointment.financials}} -->

  <appointment-price-details
    v-if='appointment && appointment.financials'
    v-model='appointment.financials'
    @finalprice='$emit("finalprice")'
    :with-title='false' />
  </v-card-text>

  <v-card-actions v-if='!createInvoice' :class='mobileCardActionsClasses' :style='mobileCardActionsStyles' >
    <v-btn v-if='withDone' flat text @click='$emit("close")' >Done</v-btn>
    <v-spacer></v-spacer>
    <v-btn v-if='withCreate' @click='createInvoice=true' color='primary' class='mr-2' >
      <v-icon small >add</v-icon> Create invoice
    </v-btn>
  </v-card-actions>

</v-card>

</template>
<script type="text/javascript">
import {ACTIVE_APPOINTMENT_DETAIL} from '@/store/constants'

// import LineItemTable from '@/components/invoice/LineItemTable'
// import InvoiceCodes from '@/components/invoice/InvoiceCodes'
import AppointmentPriceDetails from '@/components/appointment/edit/AppointmentPriceDetails.vue'
import AppointmentListItem from '@/components/appointment/AppointmentListItem'
import AppointmentProduct from '@/components/appointment/AppointmentProduct.vue'
import AppointmentCodes from '@/components/appointment/AppointmentCodes'
import PaymentList from '@/components/statement/PaymentList.vue'
import CreateTransaction from '@/components/appointment/actions/CreateTransaction.vue'
import ConfirmInvoice from '@/components/invoice/manage/create/confirm.vue'
// import QuickCreate from '@/components/invoice/manage/QuickCreate.vue'
// import ProductSheet from '@/components/pickers/ProductSheet'
import InvoiceList from '@/components/invoice/InvoiceList'

const PANELS = {
  INFO: 0,
  CODES: 1,
  PRODUCTS: 2,
  INVOICES: 3,
  PAYMENTS: 4
}

export default {
  name: 'InvoiceDetails',
  components: {
    AppointmentCodes,
    AppointmentProduct,
    AppointmentListItem,
    AppointmentPriceDetails,
    PaymentList,
    CreateTransaction,
    ConfirmInvoice,
    // ProductSheet,
    InvoiceList
  },
  props: {
    value: { type: Object, default: () => { return {} } },
    closeable: { type: Boolean, default: true },
    withCreate: { type: Boolean, default: true },
    withDone: { type: Boolean, default: true }
    // touch: { type: Number, default: 1 }
  },
  data () {
    return {
      invoice: {},
      activePanel: null,
      createInvoice: false,
      addPaymentDialog: false,
      touchPayment: 0,
      PANELS: PANELS,
      reqId: ACTIVE_APPOINTMENT_DETAIL,
      fetchAppointmentTimeout: null,
      appointment: {},
      editReqId: 'invoice-edit-appointment-request',
      invoiceReqId: 'get-invoices-for-appt',
      readyForInvoicing: null,
      discountdialog: false,
      showDescription: false,
      showProductPicker: false,
      selectedProduct: null,
      codeLineItemSubTotal: 0,
      invoiceTitle: null,
      invoiceDescription: null,
      editTitle: false,
      addCodes: false,
      requests: {
        set_discount: {
          resource: 'ag.practitioner.appointments',
          extra: 'actions/set_discount',
          method: 'post'
        }
      },
      appointmentPriceRules: [
        (v) => !!v || 'Price is required'
        // (v) => parseFloat(v) === parseFloat(this.codeLineItemSubTotal) || 'Warning: appointment title and sum of lineitems do not match'
      ]
    }
  },
  mounted () {
    if (this.value) { this.appointment = this.value }
  },
  watch: {
    appointmentId: {
      immediate: true,
      handler () {
        if (this.appointmentId) {
          this.activePanel = null
          this.loadAppointment()
          // this.loadInvoices()
        }
      }
    },
    // touch () {
    //   if (this.appointmentId) {
    //     this.loadAppointment()
    //     // this.loadInvoices()
    //   }
    // },
    value () {
      if (this.value) {
        this.appointment = this.value
      }
    },
    activePanel () {
      if (this.activePanel === PANELS.INVOICES) {
        this.loadInvoices()
      }
    },
    appointment () {
      this.$emit('input', this.appointment)
    },
    appointmentRequestStatus () {
      if (this.appointmentRequestStatus === 200) {
        this.appointment = this.appointmentRequest.result.data
        this.invoiceTitle = this.appointment.invoice_title || this.appointmentInvoiceTitle
        this.invoiceDescription = this.appointment.invoice_description
        this.editTitle = false
      }
    },
    appointmentDiscountStatus () {
      if (this.appointmentDiscountStatus === 200) {
        this.loadAppointment()
      }
    },
    appointmentEditRequestStatus () {
      if (this.appointmentEditRequestStatus === 200) {
        this.loadAppointment()
        // this.getAppointmentsInRange()
      }
    },
    readyForInvoicing () {
      if (this.readyForInvoicing !== null) {
        this.markAsInvoiceable(this.readyForInvoicing)
      }
    }
  },
  computed: {
    appointmentId () {
      if (this.appointment.id) {
        return this.appointment.id
      }
      return 0
    },
    appointmentInvoiceTitle () {
      if (this.appointment.invoice_title) { return this.appointment.invoice_title }
      let title = this.appointment.title
      if (!title) {
        title = this.appointment.full_name
      }
      let appointmentDateFormatted = this.dateformat(this.appointment.start_time, 'ddd DD MMM YYYY')
      return `${title}. ${appointmentDateFormatted}`
    },
    computedRelationship () {
      if (this.appointment && this.appointment.relationships && this.appointment.relationships.length > 0) {
        return this.appointment.relationships[0].relationship
      }
      return null
    },
    appointmentRequest () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    appointmentDetail () {
      return this.getObjectPath(this.appointmentRequest, 'result.data', {})
    },
    appointmentRequestStatus () {
      return this.appointmentRequest.status
    },
    appointmentEditRequest () {
      return this.$store.getters.getRequestById(this.editReqId, true)
    },
    appointmentEditRequestStatus () {
      return this.appointmentEditRequest.status
    },
    appointmentDiscountStatus () {
      return this.requests.set_discount.status
    },
    invoices () {
      return this.getObjectPath(this.invoiceRequest, 'result.data.results', [])
    },
    invoiceRequest () {
      return this.$store.getters.getRequestById(this.invoiceReqId, true)
    },
    isPaid () {
      return this.appointment.status === 'P'
    },
    hasCodes () {
      return (this.appointment.codes && this.appointment.codes.length > 0)
    },
    invoiceableStatus () {
      if (this.appointmentEditRequest.loading) { return 'updating..' }
      if (this.appointment) {
        if (this.appointment.invoiceable === true) {
          return 'Appointment IS READY for invoicing'
        }
      }
      return 'Appointment is NOT ready for invoicing'
    },
    formattedStatus () {
      if (this.appointment && this.appointment.status) {
        let formatted = this.formatStatus(this.appointment.status)
        if (formatted) { return formatted }
      }
      return {}
    },
    product () {
      if (Number.isInteger(parseInt(this.appointment.product))) {
        return this.getProductById(this.appointment.product, true)
      }
      return this.appointment.product
    },
    appointmentPriceHint () {
      if (this.hasCodes) {
        return 'Price is the sum of medical aid line items. It is not editable'
      }
      return 'The price for this appointment as will be used for invoicing'
    }
  },
  methods: {
    save () {
      this.$metadataguru
        .resource('lineitems')
          .create(JSON.stringify(this.lineitems))
    },
    setDiscount () {
      if (!this.appointment.discount_amount) {
        this.appointment.discount_amount = 0
      }
      this.requests.set_discount.data = {
        discount_amount: this.appointment.discount_amount,
        appointment: this.appointment.id
      }
      this.requests.set_discount.resourceId = this.appointment.id
      this.$request('save', this.requests.set_discount)
    },
    setAppointmentPrice (price) {
      let data = {
        price: price
      }
      this.$appointmentguru
        .resource('appointment')
        .save(this.appointment.id, data)
      this.appointment.price = price
    },
    saveAppointmentProduct (productId) {
      let data = { product: productId }
      this.$appointmentguru
        .resource('appointment')
        .id(this.editReqId)
        .save(this.appointment.id, JSON.stringify(data))
    },
    saveAppointmentDetails () {
      if (this.appointmentEditRequest.loading) { return false }
      let data = {
        price: this.appointment.price,
        invoice_title: this.invoiceTitle,
        invoice_description: this.invoiceDescription
      }
      this.$appointmentguru
        .resource('appointment')
        .id(this.editReqId)
        .save(this.appointment.id, JSON.stringify(data))
    },
    markAsInvoiceable () {
      let data = {invoiceable: this.appointment.invoiceable}
      this.$appointmentguru
        .resource('appointment')
        .id(this.editReqId)
        .save(this.appointment.id, data)
    },
    productSelected (data) {
      /*
       todo:
       * don't edit appointment directly.

       */
      this.appointment.product = data.product
      this.saveAppointmentProduct(data.product.id)
      this.showProductPicker = false
    },
    loadAppointment () {
      if (this.appointmentId && !this.appointmentRequest.loading) {
        this.getAppointment(this.appointmentId)
      }
    },
    loadInvoices () {
      let params = {
        appointments: this.appointment.id
      }
      this.$invoiceguru
        .resource('invoices')
        .id(this.invoiceReqId)
        .list(params)
    },
    launchInvoiceDialog () {
      let client = this.appointmentDetail.client
      let options = {
        appointments: [this.appointment],
        client
      }
      this.launchQuickInvoiceDialog(options)
    },
    gotoInvoice (invoice) {
      this.$router.push('/invoices/' + invoice.id)
      this.$emit('close')
    },
    codeLineItemSubTotalChanged (newValue) {
      this.codeLineItemSubTotal = newValue
    }
  },
  i18n: {
    messages: {
      en: {
        titles: {
          invoices: 'Invoices'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// InvoiceDetails.vue?5b58f230